import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  location: string;
  image: string;
  delay?: number;
}
export function TestimonialCard({
  quote,
  name,
  location,
  image,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-[#F7F4EF] p-8 rounded-xl relative flex flex-col h-full border border-[#E6D3B3]/30" data-id="element-467">
      <div className="w-10 h-10 rounded-full bg-white border-2 border-[#E6D3B3] flex items-center justify-center mb-6 shadow-sm" data-id="element-468">
        <Quote className="w-5 h-5 text-[#C9A961]" strokeWidth={1.75} data-id="element-469" />
      </div>

      <p className="text-[#2E2E2E] text-lg leading-relaxed italic mb-6 flex-grow" data-id="element-470">
        "{quote}"
      </p>

      <div className="flex items-center mt-auto" data-id="element-471">
        <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-white shadow-sm" data-id="element-472" />
        <div data-id="element-473">
          <h4 className="font-semibold text-[#2E2E2E]" data-id="element-474">{name}</h4>
          <p className="text-sm text-[#888888]" data-id="element-475">{location}</p>
        </div>
      </div>
    </motion.div>;
}